import React, { useEffect, useState } from 'react'
import ReactApexChart from "react-apexcharts";
import ChartHeader from '../ChartHeader';
import { images } from '../../common/images';

export default function NetKwhKvah({ totalKwh, totalKvah, ppu }) {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (totalKwh === undefined || totalKvah === undefined) return

    let categories = [""]
    let data = [
      {
        name: "kWh",
        data: [totalKwh]
      },
      {
        name: "kVAh",
        data: [totalKvah]
      }
    ]

    setSeries(data)

    setOptions({
      colors: ['#ffbc4a', '#1AC821'],
      chart: {
        stacked: false,
        toolbar: {
          show: true
        }
      },

      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '40%',
          endingShape: 'rounded',
          distributed: false,
          borderRadius: 5.556,
          borderRadiusApplication: 'end',
          dataLabels: {
            position: 'top',
          },
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: categories,
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
      },
      yaxis: {
        title: {
          text: 'Kwh Kvah'
        },
        labels: {
          formatter: function (val) {
            return `${(val).toFixed(2)} `
          },
        },
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return `${(val).toFixed(5)}`
          }
        }
      }

    })

  }, [totalKwh, totalKvah, ppu])

  return (
    <div>
      <ChartHeader
        // name={"Carbon Footprint Consumed"}

        name={"kWh vs kVAh"}
        image={images.moneySpent}
        textColor={"#1AC821"}
        iconBackgroundColor={"rgba(26, 200, 33, 0.10)"}
      />
      {
        series.length > 0 && <ReactApexChart
          series={series}
          options={options}
          type="bar"
          height={215}
        />
      }
    </div>
  )
}